const __kpWishlist = () => {
  // Variables
  const __kpWishlistBtnAll = document.querySelectorAll("a.kp-wishlist_btn");
  let __kpWishlistLocalJson = JSON.parse(
    localStorage.getItem("__kpWishlistLocalJson")
  );
  
  const __kpWishlistPopup = `
    <div id="kp-wishlist_popup" class="kp-wishlist-popup">
        <div class="popup__inner">
            <div class="popup__header">
                <h2 class="popup__heading">Wishlist (<span class="kp-wishlist_count">0</span>)</h2>
                <span class="popup__close" aria-label="Close">
                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                      <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
                    </svg>
                </span>
            </div>
            <wishlist-popup-items><ul id="kp-items_list"></ul></wishlist-popup-items>
        </div>
    </div><div id="kp-wishlist_popup_overlay" class=""></div>`;
  
  // Functions Declare
  const __kpInitPageLoad = async () => {
    document.body.insertAdjacentHTML("beforeend", __kpWishlistPopup);
    __kpCheckWishlist();
    __kpGetWIshlistData();
  };
  
  const __kpGetProductByHandle = async (handle) => {
    return await fetch(`/products/${handle}.js`).then((response) =>
      response.json()
    );
  };
  
  const __kpInsertItemHtml = async (itemHandle) => {
    const item = await __kpGetProductByHandle(itemHandle);
    const __kpWishlistItemHtml = `<li class="item-list">
          <div class="item-image">
            <img src="${item.featured_image}" alt="${
      item.title
    }" width="80" height="" />
          </div>
          <div class="item-info">
            <h4 class="item-title h4"><a href="${item.url}">${item.title}</a></h4>
            <p class="item-price">${__kpMoneyFormate(item.price)}</p>
            <div class="add-to-cart">
              <button type="submit" name="add" class="product-form__submit button button--full-width button--secondary" var_id="${
                item.variants[0].id
              }"
              ${item.variants[0].available ? "" : "disabled"}
              >
              <span>
                ${
                  item.variants[0].available
                    ? variantStrings.addToCart
                    : variantStrings.soldOut
                }
              </span>
              </button>
            </div>
            <a href="javascript:void(0);" class="kp-wishlist-remove" data-product-handle="${
              item.handle
            }">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15" fill="none">
                <path d="M12.6875 3.125H1" stroke="#ffffff" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M5.25 6.3125V10.5625" stroke="#ffffff" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M8.4375 6.3125V10.5625" stroke="#ffffff" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
                <path
                  d="M11.625 3.125V13.2188C11.625 13.3596 11.569 13.4948 11.4694 13.5944C11.3698 13.694 11.2346 13.75 11.0938 13.75H2.59375C2.45285 13.75 2.31773 13.694 2.2181 13.5944C2.11847 13.4948 2.0625 13.3596 2.0625 13.2188V3.125"
                  stroke="#ffffff" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
                <path
                  d="M9.5 3.125V2.0625C9.5 1.78071 9.38806 1.51046 9.1888 1.3112C8.98954 1.11194 8.71929 1 8.4375 1H5.25C4.96821 1 4.69796 1.11194 4.4987 1.3112C4.29944 1.51046 4.1875 1.78071 4.1875 2.0625V3.125"
                  stroke="#ffffff" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </a>
          </div>
          <div class="wishlist-loader" style="display:none"><div class="spinner"></div></div>
      </li>`;
    if (document.getElementById("kp-items_list") !== null) {
      document
        .getElementById("kp-items_list")
        .insertAdjacentHTML("afterbegin", __kpWishlistItemHtml);
    }
  };
  const __kpGetWIshlistData = async () => {
    if (__kpWishlistLocalJson !== null && __kpWishlistLocalJson.length > 0) {
      if (document.getElementById("kp-items_list") !== null) {
        document.getElementById("kp-items_list").innerHTML = "";
      }
      __kpWishlistLocalJson.forEach((item) => {
        __kpInsertItemHtml(item.product_handle);
      });
      setTimeout(() => {
        __kpAddToCartFromWishlist();
        __kpRemoveFromWishlistByLink();
      }, 1000);
    } else {
      if (document.getElementById("kp-items_list") !== null) {
        document.getElementById(
          "kp-items_list"
        ).innerHTML = `<li class="empty-wishlist">There is no item in wishlist</li>`;
      }
    }
  };
  const __kpCheckWishlist = () => {
    if (__kpWishlistLocalJson !== null && __kpWishlistLocalJson.length > 0) {
      document.querySelector("#kp-wishlist_icon .kp-wishlist_count").textContent =
        __kpWishlistLocalJson.length;
      document.querySelector("#kp-wishlist_popup .kp-wishlist_count").textContent =
        __kpWishlistLocalJson.length;
      if (__kpWishlistBtnAll !== null) {
        __kpWishlistBtnAll.forEach(function (__kpWishlistBtn) {
          const __kpProductHandle = __kpWishlistBtn.dataset.productHandle;
          const __kpExistValue = __kpWishlistLocalJson.some(
            (k) => k.product_handle === __kpProductHandle
          );
          if (__kpExistValue) {
            __kpWishlistBtn.classList.add("added");
            __kpWishlistBtn.innerHTML = __rt.remove_from_wishlist;
          } else {
            __kpWishlistBtn.classList.remove("added");
            __kpWishlistBtn.innerHTML = __rt.add_to_wishlist;
          }
        });
      }
    } else {
      if (__kpWishlistBtnAll !== null) {
        __kpWishlistBtnAll.forEach(function (__kpWishlistBtn) {
          __kpWishlistBtn.innerHTML = __rt.add_to_wishlist;
        });
      }
    }
  };
  
  const __kpWishlistPopupOpen = () => {
    document.getElementById("kp-wishlist_popup").classList.add("open");
    document.getElementById("kp-wishlist_popup_overlay").classList.add("active");
    document.body.classList.add("kp-wishlist-expanded");
    __kpRemoveFromWishlistByLink();
  };
  
  const __kpWishlistPopupClose = () => {
    document.getElementById("kp-wishlist_popup").classList.remove("open");
    document
      .getElementById("kp-wishlist_popup_overlay")
      .classList.remove("active");
    document.body.classList.remove("kp-wishlist-expanded");
  };
  const __kpWishlistCountIncrement = () => {
    let __rtWishlistCount = parseInt(
      document.querySelector("#kp-wishlist_icon .kp-wishlist_count").textContent
    );
    document.querySelector("#kp-wishlist_icon .kp-wishlist_count").textContent =
      ++__rtWishlistCount;
    document.querySelector("#kp-wishlist_popup .kp-wishlist_count").textContent =
      __rtWishlistCount;
  };
  
  const __kpWishlistCountDecrement = () => {
    let __rtWishlistCount = parseInt(
      document.querySelector("#kp-wishlist_icon .kp-wishlist_count").textContent
    );
    document.querySelector("#kp-wishlist_icon .kp-wishlist_count").textContent =
    --__rtWishlistCount;
    document.querySelector("#kp-wishlist_popup .kp-wishlist_count").textContent =
    __rtWishlistCount;
  };
  
  const __kpAddToWishlist = (self, __kpWishlistItemData) => {
    self.classList.add("adding");
    __kpWishlistLocalJson.unshift(__kpWishlistItemData);
    localStorage.setItem(
      "__kpWishlistLocalJson",
      JSON.stringify(__kpWishlistLocalJson)
    );
  
    __kpGetWIshlistData();
    setTimeout(() => {
      self.classList.remove("adding");
      self.classList.add("added");
      self.innerHTML = __rt.remove_from_wishlist;
      __kpWishlistCountIncrement();
      __kpWishlistPopupOpen();
      $("#resultLoading").hide();
    }, 500);
  };
  const __kpRemoveFromWishlist = (self, __kpIndexItem) => {
    if (__kpIndexItem > -1) {
      self.classList.add("adding");
      __kpWishlistLocalJson.splice(__kpIndexItem, 1);
      localStorage.setItem(
        "__kpWishlistLocalJson",
        JSON.stringify(__kpWishlistLocalJson)
      );
      __kpGetWIshlistData();
      setTimeout(() => {
        self.classList.remove("adding");
        self.classList.remove("added");
        self.innerHTML = __rt.add_to_wishlist;
        __kpWishlistCountDecrement();
        $("#resultLoading").hide();
      }, 500);
    }
  };
  const __kpRemoveFromWishlistByLink = () => {
    if (__kpWishlistLocalJson !== null && __kpWishlistLocalJson.length > 0) {
      document
        .querySelectorAll("#kp-items_list li.item-list")
        .forEach((__kpWishlistItem) => {
          __kpWishlistItem
            .querySelector(".kp-wishlist-remove")
            .addEventListener("click", function () {
              const self = this;
              const __kpProductHandle = self.dataset.productHandle;
              const __kpIndexItem = __kpWishlistLocalJson.findIndex(
                (k) => k.product_handle === __kpProductHandle
              );
              if (__kpIndexItem > -1) {
                __kpWishlistLocalJson.splice(__kpIndexItem, 1);
                localStorage.setItem(
                  "__kpWishlistLocalJson",
                  JSON.stringify(__kpWishlistLocalJson)
                );
                __kpWishlistItem.remove();
                __kpWishlistCountDecrement();
                __kpCheckWishlist();
                if (
                  document.querySelectorAll("#kp-items_list li.item-list")
                    .length < 1
                ) {
                  document.getElementById(
                    "kp-items_list"
                  ).innerHTML = `<li class="empty-wishlist">There is no item in wishlist</li>`;
                }
                setTimeout(() => {
                  __kpRemoveFromWishlistByLink();
                }, 1000);
              }
            });
        });
    }
  };
  
  const __kpActionATC = (atcBtn, selectedVariantId, removeLink, loader) => {
    atcBtn.addEventListener("click", async () => {
      loader.style.display = "flex";
      let addCart = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ quantity: 1, id: selectedVariantId }),
      });
      addCart = await addCart.json();
      
      setTimeout(async () => {
        let cartRes = await fetch(window.location.href);
        cartRes = await cartRes.text();
        let parser = new DOMParser();
        let doc = parser.parseFromString(cartRes, "text/html");
        let minicartUpdate = doc.querySelector(".mini-cart").innerHTML;
        document.querySelector(".mini-cart").innerHTML = minicartUpdate;
        removeLink.click();
        loader.style.display = "none";
      }, 500);
    });
  };
  
  const __kpAddToCartFromWishlist = () => {
    const itemList = document.querySelectorAll("#kp-items_list li.item-list");
    itemList.forEach((option, index) => {
      const atcBtn = option.querySelector(".add-to-cart button");
      const removeLink = option.querySelector(".kp-wishlist-remove");
      const loader = option.querySelector(".wishlist-loader");
      __kpActionATC(atcBtn, atcBtn.getAttribute("var_id"), removeLink, loader);
    });
  };
  const __kpMoneyFormate = (price) => {
    return __rt.money_format.replace("{{amount}}", price / 100);
  };
  
  // Initial Function Call
  __kpInitPageLoad();
  
  //click Events
  document
    .getElementById("kp-wishlist_icon")
    .addEventListener("click", function () {
      __kpWishlistPopupOpen();
    });
  
  document
    .querySelector("#kp-wishlist_popup .popup__close")
    .addEventListener("click", function () {
      __kpWishlistPopupClose();
    });
  document
    .querySelector("#kp-wishlist_popup_overlay")
    .addEventListener("click", function () {
      __kpWishlistPopupClose();
    });
  
  //click on add to wishlist button
  if (__kpWishlistBtnAll !== null) {
    __kpWishlistBtnAll.forEach((__kpWishlistBtn) => {
      __kpWishlistBtn.addEventListener("click", function () {
        const self = this;
        const __kpProductHandle = self.dataset.productHandle;
        const __kpWishlistItemData = JSON.parse(
          `{"product_handle": "${__kpProductHandle}"}`
        );
        $("#resultLoading").show();
        if (__kpWishlistLocalJson !== null && __kpWishlistLocalJson.length > 0) {
          const __kpExistValue = __kpWishlistLocalJson.some(
            (k) => k.product_handle === __kpProductHandle
          );
          const __kpIndexItem = __kpWishlistLocalJson.findIndex(
            (k) => k.product_handle === __kpProductHandle
          );
          if (__kpExistValue) {
            __kpRemoveFromWishlist(self, __kpIndexItem);
          } else {
            __kpAddToWishlist(self, __kpWishlistItemData);
          }
        } else {
          if (__kpWishlistLocalJson == null) {
            __kpWishlistLocalJson = [];
          }
          __kpAddToWishlist(self, __kpWishlistItemData);
        }
      });
    });
  }
}
__kpWishlist();